exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1T_6 {\n    max-width: 550px;\n    border: 1px solid #e4e8eb;\n    border-radius: 6px;\n    background-color: white;\n}\n\n.bsfJ {\n    text-align: center;\n    margin-bottom: 15px;\n    padding: 0 20px;\n}\n\n._qlv {\n    padding: 0 15px;\n    margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_1T_6",
	"chatNow": "bsfJ",
	"blogPostsContainer": "_qlv"
};